import PropTypes from 'prop-types'
import React from 'react'
import Nav from './Nav'
import Shortcuts from './Shortcuts'
import styles from './_header.css'

export default function Header (props) {
  const { showShortcuts, loggedIn } = props

  return (
    <div className={styles.container}>
      <div className={styles.nav}>
        <Nav {...props} />
      </div>
      {showShortcuts && loggedIn ?
        <div className={styles.shortcuts}>
          <Shortcuts {...props} />
        </div>
      : null}
    </div>
  )
}

Header.propTypes = {
  showShortcuts: PropTypes.bool,
  loggedIn: PropTypes.bool,
}
